import { Component, HostBinding, Input } from '@angular/core';

import { IToaster } from '../../../_interfaces/toaster.interface';
import { SdHtmlComponent } from '../../html/html.component';

@Component({
  selector: 'sd-toaster',
  templateUrl: './toaster.component.html',
  standalone: true,
  imports: [SdHtmlComponent]
})
export class SdToasterComponent {
  @Input()
  toasterData: IToaster;

  @Input() class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.toasterData?.status ? 'is-' + this.toasterData?.status : ''
    ]
      .filter(Boolean)
      .join(' ');
  }
}
